export interface EventWizardRegistrationsButtonTextProps {
// add props here
}

export const REGISTER_BTN_TEXT_PANEL_ID = 'Register_Btn_Panel_ID';